import React from 'react';
import { TrendingUp, Globe, Layers, Rocket, Building2, Mail } from 'lucide-react';
import SEO from '../../components/SEO';

const IsBirlikleriPage = () => {
  return (
    <>
      <SEO
        title="Stratejik İş Birlikleri"
        description="Borsamex, global ölçekte büyüme hedefleri doğrultusunda stratejik iş birliklerine açıktır."
        keywords="borsamex, stratejik iş birliği, partnership, fintech"
        url="/kurumsal/is-birlikleri"
      />
      
      <div className="min-h-screen bg-brand-dark">
        {/* Hero Section */}
        <section className="pt-24 pb-16 px-6">
          <div className="container mx-auto max-w-4xl">
            <div className="text-center mb-12">
              <div className="inline-flex items-center gap-2 px-4 py-2 bg-blue-500/10 border border-blue-500/20 rounded-full mb-6">
                <Building2 className="h-4 w-4 text-blue-400" />
                <span className="text-sm text-blue-400 font-medium">Kurumsal</span>
              </div>
              <h1 className="text-3xl md:text-4xl font-bold text-white mb-6">
                Stratejik İş Birlikleri
              </h1>
              <p className="text-lg text-slate-400 max-w-2xl mx-auto leading-relaxed mb-4">
                Borsamex, global ölçekte büyüme hedefleri doğrultusunda 
                stratejik iş birliklerine açıktır.
              </p>
              <p className="text-sm text-slate-500 max-w-xl mx-auto">
                Teknoloji, veri, dağıtım ve kurumsal çözümler odağında uzun vadeli ortaklıklar geliştiriyoruz.
              </p>
            </div>
          </div>
        </section>

        {/* Vizyon */}
        <section className="py-16 px-6 border-t border-white/5">
          <div className="container mx-auto max-w-4xl">
            <div className="flex items-start gap-6">
              <div className="w-12 h-12 bg-primary/10 rounded-xl flex items-center justify-center flex-shrink-0">
                <TrendingUp className="h-6 w-6 text-primary" />
              </div>
              <div>
                <h2 className="text-2xl font-bold text-white mb-4">Vizyon</h2>
                <p className="text-slate-400 leading-relaxed">
                  Bireysel yatırımcıların finansal araçlara erişimini demokratikleştiren, 
                  şeffaf ve teknoloji odaklı bir ekosistem inşa ediyoruz. Amacımız, 
                  trading stratejilerinin oluşturulması, test edilmesi ve paylaşılması 
                  süreçlerini herkes için erişilebilir kılmak.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Ekosistem Yaklaşımı */}
        <section className="py-16 px-6 bg-white/[0.01]">
          <div className="container mx-auto max-w-4xl">
            <div className="flex items-start gap-6">
              <div className="w-12 h-12 bg-blue-500/10 rounded-xl flex items-center justify-center flex-shrink-0">
                <Layers className="h-6 w-6 text-blue-400" />
              </div>
              <div>
                <h2 className="text-2xl font-bold text-white mb-4">Ekosistem Yaklaşımı</h2>
                <p className="text-slate-400 leading-relaxed mb-6">
                  Borsamex, tek başına bir ürün değil; strateji geliştiricileri, sinyal 
                  sağlayıcıları ve yatırımcıları bir araya getiren bir ekosistem olarak 
                  konumlanmaktadır.
                </p>
                <div className="grid sm:grid-cols-3 gap-4">
                  <div className="p-4 bg-white/[0.02] border border-white/5 rounded-lg text-center">
                    <p className="text-2xl font-bold text-white mb-1">3</p>
                    <p className="text-xs text-slate-500 mb-2">Gelir Modeli</p>
                    <p className="text-[10px] text-slate-600">Abonelik, komisyon ve sağlayıcı gelirleri</p>
                  </div>
                  <div className="p-4 bg-white/[0.02] border border-white/5 rounded-lg text-center">
                    <p className="text-2xl font-bold text-white mb-1">Hibrit</p>
                    <p className="text-xs text-slate-500 mb-2">Bot + Sinyal</p>
                    <p className="text-[10px] text-slate-600">Bot + insan sinyali birlikte</p>
                  </div>
                  <div className="p-4 bg-white/[0.02] border border-white/5 rounded-lg text-center">
                    <p className="text-2xl font-bold text-white mb-1">Canlı</p>
                    <p className="text-xs text-slate-500 mb-2">Performans Önceliği</p>
                    <p className="text-[10px] text-slate-600">Backtest değil, gerçek piyasa verisi</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Büyüme Perspektifi */}
        <section className="py-16 px-6 border-t border-white/5">
          <div className="container mx-auto max-w-4xl">
            <div className="flex items-start gap-6">
              <div className="w-12 h-12 bg-amber-500/10 rounded-xl flex items-center justify-center flex-shrink-0">
                <Rocket className="h-6 w-6 text-amber-400" />
              </div>
              <div>
                <h2 className="text-2xl font-bold text-white mb-4">Büyüme Perspektifi</h2>
                <p className="text-slate-400 leading-relaxed">
                  Platform, ürün-pazar uyumunu güçlendirmektedir. Türkiye pazarında başlayan 
                  yolculuğumuz, bölgesel ve ardından global pazarlara açılım hedefi taşımaktadır.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* İş Birliği Türleri */}
        <section className="py-16 px-6 bg-white/[0.01]">
          <div className="container mx-auto max-w-4xl">
            <div className="flex items-start gap-6">
              <div className="w-12 h-12 bg-purple-500/10 rounded-xl flex items-center justify-center flex-shrink-0">
                <Globe className="h-6 w-6 text-purple-400" />
              </div>
              <div>
                <h2 className="text-2xl font-bold text-white mb-4">İş Birliği Alanları</h2>
                <p className="text-slate-400 leading-relaxed mb-6">
                  Aşağıdaki alanlarda stratejik iş birliği fırsatlarını değerlendirmekteyiz:
                </p>
                <ul className="space-y-3">
                  <li className="flex items-center gap-3 text-slate-300">
                    <span className="w-1.5 h-1.5 bg-primary rounded-full" />
                    Teknoloji ve altyapı ortaklıkları
                  </li>
                  <li className="flex items-center gap-3 text-slate-300">
                    <span className="w-1.5 h-1.5 bg-primary rounded-full" />
                    Veri ve analitik entegrasyonları
                  </li>
                  <li className="flex items-center gap-3 text-slate-300">
                    <span className="w-1.5 h-1.5 bg-primary rounded-full" />
                    Dağıtım ve erişim kanalları
                  </li>
                  <li className="flex items-center gap-3 text-slate-300">
                    <span className="w-1.5 h-1.5 bg-primary rounded-full" />
                    Kurumsal çözümler ve B2B modelleri
                  </li>
                  <li className="flex items-center gap-3 text-slate-300">
                    <span className="w-1.5 h-1.5 bg-primary rounded-full" />
                    Bölgesel genişleme ortaklıkları
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* İletişim - Subtle */}
        <section className="py-16 px-6 border-t border-white/5">
          <div className="container mx-auto max-w-4xl">
            <div className="p-8 bg-gradient-to-br from-blue-500/5 to-primary/5 border border-white/5 rounded-2xl text-center">
              <Mail className="h-8 w-8 text-slate-400 mx-auto mb-4" />
              <h3 className="text-lg font-semibold text-white mb-3">
                İletişime Geçin
              </h3>
              <p className="text-sm text-slate-400 mb-6 max-w-md mx-auto">
                Stratejik iş birliği fırsatlarını görüşmek için bizimle iletişime geçebilirsiniz.
              </p>
              <a
                href="mailto:partnerships@borsamex.com"
                className="inline-flex items-center gap-2 text-primary hover:text-primary/80 transition-colors"
              >
                <Mail className="h-4 w-4" />
                partnerships@borsamex.com
              </a>
              <p className="text-xs text-slate-600 mt-4">
                Tüm başvurular gizlilikle değerlendirilir.
              </p>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default IsBirlikleriPage;
